export default "__VITE_ASSET__BQKoZC1J__"